import React from 'react';
import { Alert, Button, InfoOutlinedIcon, Text } from '@billda/design-system';
import { useNavigate } from 'react-router-dom';
import { Routes as AppRoutes } from '../../../routes';

const InvitationDeclinedPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="mx-auto w-full max-w-[600px] px-4">
      <div className="mt-16">
        <div className="rounded-xl border border-border-default bg-surface-default p-8 text-center shadow-lg">
          <InfoOutlinedIcon
            aria-hidden="true"
            className="mb-4 size-[60px] text-content-info"
          />

          <Text as="div" variant="h5" className="mb-2">
            Invitation Declined
          </Text>

          <Alert severity="info" className="mt-4 mb-6 text-left">
            You have chosen not to share your information with this
            organisation.
          </Alert>

          <Text as="div" variant="body1" color="secondary" className="mb-8">
            The invitation remains valid if you change your mind. You can use
            the invitation link again to accept the invitation and share your
            information.
          </Text>

          <Text as="div" variant="body2" color="secondary" className="mb-8">
            If you have any concerns about data sharing, please contact your
            administrator for more information.
          </Text>

          <Button
            variant="neutral"
            onClick={() => navigate(AppRoutes.root)}
            data-testid="go-to-login-button"
          >
            Go to Login
          </Button>
        </div>
      </div>
    </div>
  );
};

export default InvitationDeclinedPage;
